import { render } from "./SelectBox.vue?vue&type=template&id=740d1ba2"
import script from "./SelectBox.vue?vue&type=script&lang=js"
export * from "./SelectBox.vue?vue&type=script&lang=js"

import "./SelectBox.vue?vue&type=style&index=0&id=740d1ba2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__